import debounce from 'lodash.debounce';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class EditorialPreheader {
	constructor(elm) {
        this.elm = elm;

        this.breakpoint = window.matchMedia('(min-width:992px)');

        this.preheaderMedia = this.elm.querySelector('[data-preheader-media]');

        const imgVideo = this.preheaderMedia.querySelector('.c-img-video');
        if(!imgVideo) {
            gsap.to(window, {
                duration: 2,
                ease: 'power2.inOut',
                delay: 1,
                scrollTo: {
                    y: this.breakpoint.matches ? (this.preheaderMedia.getBoundingClientRect().height*2) - 46 : (this.preheaderMedia.getBoundingClientRect().height*2) - 32
                }
            });
        }

        this.tl = gsap.timeline({
            paused: true,
            scrollTrigger: {
                trigger: this.elm,
                start: "bottom bottom",
                end: "bottom "+window.outerHeight/2,
                scrub: 0.5
            }
        });
        this.tl.to(this.preheaderMedia, {
            opacity: 0,
            duration: 1,
            ease: 'none',
        });

        this.init();
    }

    init() {

        // Resize
        this.boundResizeListener = debounce(() => {
            this.resize();
        }, 0);
		window.addEventListener(
			'resize',
			this.boundResizeListener
		);
        this.resize();
    }

    resize() {
        const headerHeight = this.elm.getBoundingClientRect().height;

        let top = 0+'px';
        if(headerHeight>window.outerHeight) {
            top = (headerHeight-window.outerHeight)*-1+'px'
        }
        gsap.set(this.elm, {
            top: top
        });

        ScrollTrigger.refresh(true);
    }

    destroy() {
        window.removeEventListener('resize', this.boundResizeListener);
    }

}